import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoPokerstars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 160,
	height: 28,
	viewBox: "0 0 160 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_46_3923)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M43.3388 11.8974C43.3388 14.3787 41.7403 16.0971 38.6725 16.0971H35.1972V20.1425H32.2616V8.00015H39.1899C41.8457 8.00015 43.3388 9.46664 43.3388 11.8974ZM40.2835 11.9318C40.2835 10.7675 39.537 10.2987 38.4434 10.2987H35.1972V13.6664H38.1999C39.5653 13.6664 40.2835 13.1287 40.2835 11.9318Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M58.0627 14.1007C58.0627 18.2153 55.0577 20.317 51.3429 20.317C47.6284 20.317 44.6255 18.2153 44.6255 14.1007C44.6255 9.91713 47.6284 7.81131 51.3429 7.81131C55.0577 7.81131 58.0627 9.91713 58.0627 14.1007ZM54.938 14.1007C54.938 11.5138 53.3579 10.2459 51.3429 10.2641C49.3287 10.2825 47.7499 11.5322 47.7499 14.1007C47.7499 16.6 49.3303 17.8865 51.3429 17.8865C53.3557 17.8865 54.938 16.6184 54.938 14.1007Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M64.8386 15.1436L62.8581 17.4V20.1427H59.9185V8.00015H62.852V13.7373L67.975 8.00015H71.6269L66.8289 13.1287L72.1585 20.1427H68.5288L64.8386 15.1436Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M76.6494 10.4346V12.7818H82.6546V15.1009H76.6494V17.6594H83.3445V20.1426H73.7137V7.99997H83.3445V10.4346H76.6494Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M90.5313 15.7845H88.4495V20.1427H85.5139V7.99976H92.5641C95.3924 7.99976 96.6955 9.62274 96.6955 11.7514C96.6955 13.711 95.6016 15.2004 93.7435 15.5878L97.3542 20.1529H93.7965L90.5313 15.7845ZM88.4495 13.4413H91.6433C92.8401 13.4413 93.6394 12.9908 93.6394 11.8974C93.6394 10.7326 92.828 10.2983 91.7303 10.2983H88.4495V13.4413Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M103.832 7.81718C105.303 7.80195 106.77 7.94758 108.209 8.25149V10.7853C106.709 10.4272 105.172 10.2468 103.63 10.2479C102.187 10.2479 101.321 10.6984 101.303 11.4285C101.284 12.1592 101.771 12.4858 102.865 12.5565L105.192 12.6948C107.604 12.8348 109.028 13.9446 109.028 16.2532C109.028 19.3433 106.408 20.311 103.421 20.311C101.901 20.2985 100.385 20.1532 98.8901 19.8769V17.2777C100.408 17.6029 101.956 17.7716 103.508 17.781C105.364 17.781 106.198 17.3307 106.198 16.4093C106.198 15.6468 105.399 15.3158 104.289 15.2651L102.362 15.1596C99.9654 15.038 98.4906 13.9792 98.4906 11.8444C98.4847 9.03235 100.846 7.81718 103.832 7.81718Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M120.967 10.5257H116.939V20.1427H114.005V10.5257H109.948V7.99976H120.97L120.967 10.5257Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M130.048 17.6247H124.249L123.277 20.1426H120.1L125.081 7.99997H129.214L134.196 20.1525H131.02L130.048 17.6247ZM129.127 15.2469L127.148 10.1424L125.168 15.2469H129.127Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M140.725 15.7845H138.642V20.1427H135.708V7.99976H142.757C145.586 7.99976 146.887 9.62274 146.887 11.7514C146.887 13.711 145.794 15.2004 143.937 15.5878L147.548 20.1529H143.988L140.725 15.7845ZM138.642 13.4413H141.835C143.034 13.4413 143.832 12.9908 143.832 11.8974C143.832 10.7326 143.02 10.2983 141.923 10.2983H138.642V13.4413Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M154.024 7.81719C155.498 7.80102 157.055 7.9468 158.496 8.2515V10.7854C156.995 10.4269 155.369 10.2463 153.825 10.2479C152.385 10.2479 151.517 10.6984 151.499 11.4285C151.481 12.1592 151.967 12.4858 153.063 12.5565L155.388 12.6948C157.8 12.8348 159.308 13.9446 159.308 16.2532C159.308 19.3433 156.599 20.311 153.613 20.311C152.091 20.3009 150.573 20.1573 149.076 19.8829V17.2777C150.594 17.6026 152.142 17.7712 153.694 17.781C155.552 17.781 156.384 17.3307 156.384 16.4093C156.384 15.6468 155.587 15.3159 154.475 15.2651L152.547 15.1596C150.153 15.038 148.67 13.9792 148.67 11.8549C148.67 9.03236 151.038 7.81719 154.024 7.81719Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.4649 6.35736C13.9627 2.86147 11.7315 0.693176 11.7315 0.693176C11.7315 0.693176 9.49591 2.86147 6.00002 6.35736C4.1526 8.20255 0 12.781 0 17.3333C0 20.3678 2.46087 22.8282 5.49576 22.8282C7.48795 22.8282 9.22699 21.7665 10.1902 20.1799V20.1816C10.2873 20.0631 10.4456 19.966 10.6235 19.966C10.9064 19.966 11.1636 20.1654 11.1339 20.4125C10.9222 22.0496 10.0004 26.0831 6.3676 27.4457H17.0926C13.4605 26.0831 12.5391 22.0496 12.3288 20.4125C12.2973 20.1654 12.5567 19.966 12.8391 19.966C13.0132 19.966 13.1736 20.0631 13.2706 20.1816L13.2728 20.1799C14.232 21.7665 15.9729 22.8282 17.9649 22.8282C20.9982 22.8282 23.4608 20.3678 23.4608 17.3333C23.4608 12.781 19.3082 8.20255 17.4649 6.35736Z",
				fill: "#D70A0A"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.7313 6.36685L13.2195 10.9527H18.0427L14.1406 13.7879L15.6326 18.3734L11.7313 15.5384L7.83026 18.3734L9.32001 13.7879L5.4165 10.9527H10.2434L11.7313 6.36685Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_46_3923",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 159.327,
			height: 26.963,
			fill: "white",
			transform: "translate(0 0.518524)"
		})
	}) })]
});
export default SvgLogoPokerstars;
